import { httpRequest } from "@services/http";
import type { Role } from "./cmdListRoles";

export class CommandUpdateRole {
  async run(roleId: number, payload: { name?: string }): Promise<Role> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/roles/${roleId}`;
    try {
      return await httpRequest<Role>(url, { method: "PATCH", body: payload });
    } catch (error) {
      console.error("Error updating role:", error);
      throw error;
    }
  }
}
